import { Link } from 'react-router-dom';
import Toggle from '@/components/elements/Toggle';
import AuthorImage from '@/components/elements/AuthorImage';
import type { NotificationSettingsAuthor } from '@/types/models.types';

interface AuthorNotificationSettingsProps {
  author: NotificationSettingsAuthor;
  checked: boolean;
  disabled: boolean;
  handleToggleChange: (authorId: number, checked: boolean) => void;
  hideBottomBorder?: boolean;
}

function AuthorNotificationSettings({
  author,
  checked,
  disabled,
  handleToggleChange,
  hideBottomBorder = false,
}: AuthorNotificationSettingsProps) {
  return (
    <li
      key={author.id}
      className={`flex items-center justify-between bg-white ${
        !hideBottomBorder ? 'border-b pb-4 border-gray-200' : ''
      }`}
    >
      <div className='flex items-center gap-3'>
        <AuthorImage src={author?.image} alt={`${author?.name}'s profile picture`} />

        <div>
          <h3 className='text-base font-medium leading-[1.1rem] m-0 mt-[2px]'>
            <Link to={`/author/${author.lookupKey}`} className='transition-all hover:text-teal-700 hover:underline'>
              {author.name}
            </Link>
          </h3>
        </div>
      </div>

      <Toggle
        disabled={disabled}
        checked={checked}
        onChange={(checked) => handleToggleChange(author.lookupKey, checked)}
      />
    </li>
  );
}

export default AuthorNotificationSettings;
